import { render, staticRenderFns } from "./FormOwnerManage.vue?vue&type=template&id=369051aa"
import script from "./FormOwnerManage.vue?vue&type=script&lang=js"
export * from "./FormOwnerManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports